import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { Country } from './country.resource';
import { Enum } from './enum.resource';
import { Platform } from './platform.resource';
import { BillingChannel } from './billing-channel.resource';
import { OrderChannel } from './order-channel.resource';
import { NetworkChannel } from './network-channel.resource';
import { Job } from './job.resource';
import { BillingMode } from './billing-mode.resource';
import { Product } from './product.resource';
import { Firm } from './firm.resource';
import { BillingKinematic } from './billing-kinematic.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import {
  NumberFilter,
  StringFilter,
  EnumListFilter,
} from 'src/app/filter/filter';
import { AtomService } from '../atom.service';
import {
  BillingChannelConfig,
  BillingKinematicConfig,
  BillingModeConfig,
  CountryConfig,
  EndUserProviderJobConfig,
  FirmConfig,
  NetworkChannelConfig,
  OrderChannelConfig,
  PlatformConfig,
  ProductConfig,
} from 'src/app/shared/tools/search/search-config';

@Resource({
  type: 'cappings',
})
export class Capping extends AtomResource {
  @Attribute() value?: Number;
  @Attribute() duration?: string;
  @Attribute({ key: 'type' }) cappingType?: Enum;

  @Relationship() country?: Country;
  @Relationship() platform?: Platform;
  @Relationship() billingchannel?: BillingChannel;
  @Relationship() billingmode?: BillingMode;
  @Relationship() orderchannel?: OrderChannel;
  @Relationship() networkchannel?: NetworkChannel;
  @Relationship() enduserproviderjob?: Job;
  @Relationship() product?: Product;
  @Relationship() ownerfirm?: Firm;
  @Relationship() billingkinematic?: BillingKinematic;
  @Relationship() enumtype?: Enum;
}
export class CappingConfig implements ResourceConfig {
  tables = {
    includes: ['platform.job.firm', 'country.defaultcurrency', 'enumtype'],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main', translatable: false }],
        header: 'ID',
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'platform',
        icon: 'dns',
        displayedDatas: [
          {
            path: ['platform.name'],
            class: 'mat-body-2',
          },
        ],
        header: 'Platform',
        displayed: true,
        sort: 'name',
        link: {
          resource: 'platforms',
          filter: 'platform.id',
          icon: 'dns',
        },
      },
      {
        columnDef: 'country',
        displayedDatas: [
          {
            path: ['country.name'],
            class: 'mat-body-2',
          },
          {
            path: ['country.id'],
            class: 'mat-body-2',
          },
        ],
        header: 'Country',
        displayed: true,
        sort: 'country',
        link: {
          resource: 'countries',
          filter: 'country.id',
          icon: 'dns',
        },
        options: {
          flag: 'country.id',
        },
      },
      {
        columnDef: 'type',
        header: 'Type',
        displayed: true,
        sort: 'enumtype.label',
        displayedDatas: [
          {
            path: ['enumtype.label'],
            class: 'mat-body-2',
          },
        ],
      },
      {
        columnDef: 'max',
        header: 'MAX.',
        displayed: true,
        displayedDatas: [
          {
            path: ['value'],
            class: 'mat-body-2',
            // addUnit: {
            //   path: 'country.defaultcurrency.id',
            //   condition: {
            //     key: 'enumtype.id',
            //     value: '',
            //   },
            // },
          },
        ],
      },
      {
        columnDef: 'duration',
        header: 'Duration',
        displayed: true,
        displayedDatas: [
          {
            path: ['duration'],
            class: 'mat-body-2',
            type: 'interval',
          },
        ],
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'publish',
      title: [
        {
          path: ['platform.job.firm.name'],
        },
      ],
      subtitle: [
        {
          path: ['enumtype.label'],
        },
      ],
    },
    elements: [
      {
        list: [
          {
            icon: 'category',
            title: 'Type',
            APIKey: 'enumtype',
            value: { path: ['enumtype.label'] },
          },
          {
            icon: 'looks_one',
            title: 'Max.',
            APIKey: 'value',
            value: { path: ['value'] },
          },
          {
            icon: 'av_timer',
            title: 'Time Interval.',
            APIKey: 'duration',
            value: { path: ['duration'], type: 'interval' },
          },
          {
            icon: 'language',
            title: 'Country',
            APIKey: 'country',
            value: {
              path: ['country.name'],
            },
            link: {
              resource: 'countries',
              filter: 'country.id',
            },
            options: {
              flag: 'country.id',
            },
          },
          {
            icon: 'dns',
            title: 'Platform',
            APIKey: 'platform',
            value: {
              path: ['platform.name'],
            },
            link: {
              resource: 'platforms',
              filter: 'platform.id',
            },
          },
        ],
      },
      {
        columns: true,
        title: 'Context',
        list: [
          {
            title: 'Billing Channel',
            icon: 'local_atm',
            APIKey: 'billingchannel',
            value: { path: ['billingchannel.name'] },
          },
          {
            title: 'Billing Mode',
            icon: 'local_atm',
            APIKey: 'billingmode',
            value: { path: ['billingmode.name'] },
          },
          // {
          //   title: 'Billing Kinematic',
          //   icon: 'local_atm',
          //   APIKey: 'billingkinematic',
          //   value: { path: ['billingkinematic.name'] },
          // },
          {
            title: 'Order Channel',
            icon: 'network_cell',
            APIKey: 'orderchannel',
            value: { path: ['orderchannel.name'] },
          },
          {
            title: 'Network Channel',
            icon: 'network_cell',
            APIKey: 'networkchannel',
            value: { path: ['networkchannel.name'] },
          },
          {
            title: 'Enduser Provider',
            icon: 'signal_cellular_alt',
            APIKey: 'enduserproviderjob',
            value: { path: ['enduserproviderjob.firm.name'] },
          },
          // {
          //   title: 'Product',
          //   icon: 'public',
          //   APIKey: 'product',
          //   value: { path: ['product.name'] },
          // },
          // {
          //   title: 'Owner Firm',
          //   icon: 'business',
          //   APIKey: 'ownerfirm',
          //   value: { path: ['ownerfirm.name'] },
          // },
        ],
      },
    ],
  };
  wizard = {
    tabs: [
      {
        title: 'Capping',
        formGroup: 'capping',
        list: [
          {
            type: 'enum',
            title: 'Capping Type',
            formControl: 'cappingType',
            APIKey: 'cappingType',
            fieldKey: 'type',
            required: true,
            activatingSequence: [
              {
                group: 'capping',
                control: 'duration',
                condition: {
                  include: [
                    'sales_throttling',
                    'spending_limit',
                    'sales_cooldown',
                    'returning_users_cooldown',
                  ],
                },
              },
              // {
              //   group: 'capping',
              //   control: 'value',
              //   condition: {
              //     include: [
              //       'sales_throttling',
              //       'spending_limit',
              //       'active_subscriptions',
              //       // 'sales_cooldown',
              //       // 'returning_users_cooldown',
              //     ],
              //   },
              // },
            ],
          },
          {
            type: 'number',
            title: 'Value',
            APIKey: 'value',
            formControl: 'value',
            required: true,
            presetValue: 1,
          },
          {
            type: 'interval',
            title: 'Duration',
            APIKey: 'duration',
            formControl: 'duration',
            required: true,
            noCols: true,
          },
          {
            type: 'resource',
            title: 'Country',
            formControl: 'country',
            APIKey: 'country',
            search: new CountryConfig(this.atom),
            required: true,
            noCols: true,
            activatingSequence: [
              {
                group: 'capping',
                control: 'platform',
                filters: {
                  filter:
                    'equal.platformcapabilities.enduserproviderjob.firm.headquarterscountry.id',
                },
              },
              {
                group: 'context',
                control: 'enduserproviderjob',
                filters: {
                  filter: 'like.firm.headquarterscountry.id',
                },
              },
              {
                group: 'context',
                control: 'product',
                filters: {
                  filter: 'equal.country.id',
                },
              },
            ],
          },
          {
            type: 'resource',
            title: 'Platform',
            formControl: 'platform',
            APIKey: 'platform',
            search: new PlatformConfig(this.atom),
            required: true,
            noCols: true,
            activatingSequence: [
              {
                group: 'context',
                control: 'enduserproviderjob',
                filters: {
                  filter: 'equal.platformcapabilities.platform.id',
                },
              },
            ],
          },
        ],
      },
      {
        title: 'Context',
        formGroup: 'context',
        list: [
          {
            type: 'resource',
            title: 'Billing Channel',
            formControl: 'billingchannel',
            search: new BillingChannelConfig(),
          },
          {
            type: 'resource',
            title: 'Billing Mode',
            formControl: 'billingmode',
            search: new BillingModeConfig(),
          },
          // {
          //   type: 'resource',
          //   title: 'Billing Kinematic',
          //   formControl: 'billingkinematic',
          //   search: new BillingKinematicConfig(),
          // },
          {
            type: 'resource',
            title: 'Order Channel',
            formControl: 'orderchannel',
            search: new OrderChannelConfig(),
          },
          {
            type: 'resource',
            title: 'Network Channel',
            formControl: 'networkchannel',
            search: new NetworkChannelConfig(),
          },
          {
            type: 'resource',
            title: 'Enduser Provider',
            formControl: 'enduserproviderjob',
            APIKey: 'enduserproviderjob',
            search: new EndUserProviderJobConfig(this.atom),
            multiple: false,
          },
          // {
          //   type: 'resource',
          //   title: 'Product',
          //   formControl: 'product',
          //   APIKey: 'product',
          //   search: new ProductConfig(this.atom),
          //   multiple: false,
          // },
          // {
          //   type: 'resource',
          //   title: 'Owner Firm',
          //   formControl: 'ownerfirm',
          //   APIKey: 'ownerfirm',
          //   search: new FirmConfig(this.atom),
          //   multiple: false,
          // },
        ],
      },
    ],
  };
  resource = Capping;
  resourceKey?: string | undefined = 'cappings';
  resourceKeySingle?: string | undefined = 'capping';
  resourceName = 'cappings';
  includes = [
    'country.defaultcurrency',
    'platform.job.firm',
    'billingmode',
    'billingchannel',
    'orderchannel',
    'networkchannel',
    'enduserproviderjob.firm.headquarterscountry',
    'enduserproviderjob.activity',
    'product.country',
    'ownerfirm',
    'billingkinematic',
    'enumtype',
  ];
  filters = [
    new NumberFilter('id', 'ID'),
    new EnumListFilter(this.atom, 'cappings', 'type', 'type', 'Type'),
    new NumberFilter('platform.id', 'Platform ID'),
    new StringFilter('platform.name', 'Platform Name'),
    new StringFilter('country.id', 'Country ID', true),
    new StringFilter('country.name', 'Country Name'),
    new StringFilter('enduserproviderjob.firm.name', 'End User Provider Job'),
    new StringFilter('platform.job.firm.name', 'Billing Provider'),
  ];
  constructor(private atom: AtomService) {}
}
